import { useFormContext } from 'react-hook-form'

import { TAccountFormValues } from '@/features/update-account'
import {
  useAccountValidation,
  useUpdateGuestContractDepositReturnAccount,
} from '@/features/update-account'
import { Button } from '@/shared/ui'

type Props = {
  contractId: number
  onSuccess?: () => void
}

export const UpdateDepositReturnAccountButton = ({
  contractId,
  onSuccess,
}: Props) => {
  const { shouldValidateAccountForm, accountTrigger } = useAccountValidation()

  const { getValues } = useFormContext<TAccountFormValues>()

  const { updateDepositReturnAccount } =
    useUpdateGuestContractDepositReturnAccount({
      onSuccess,
    })

  const validateForm = async () => {
    let isValid = true

    const hasAccountChanged = shouldValidateAccountForm()

    if (hasAccountChanged) {
      const result = await accountTrigger()

      if (isValid) {
        isValid = result
      }
    }

    return isValid
  }

  const handleClick = async () => {
    const isValid = await validateForm()

    if (!isValid) {
      return
    }

    const formValues = getValues()

    updateDepositReturnAccount(contractId, formValues)
  }

  return (
    <Button
      type="button"
      variant="solid"
      color="primary"
      size="large"
      fullWidth
      onClick={handleClick}
    >
      저장하기
    </Button>
  )
}
